import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicRecordingViewIndex } from '@/pages/recording/PublicRecordingViewIndex';

const searchSchema = z.object({
	url: z.string().optional(),
});

export const Route = createFileRoute('/recording/share')({
	validateSearch: searchSchema,
	component: PublicRecordingViewIndex,
});
